import React, { useEffect, useState } from 'react';

/**
 * 필수(*) 표시용 커스텀 헤더.
 * AG Grid는 headerComponent를 쓰면 기본 헤더(정렬 UI)를 대체하므로,
 * enableSorting일 때 클릭으로 progressSort를 호출해야 컬럼명 클릭 정렬이 동작합니다.
 * @see https://www.ag-grid.com/archive/31.1.0/react-data-grid/component-header/#sorting
 */
const CustomHeader = (props) => {
  const { displayName, column, enableSorting, progressSort } = props;

  const colDef =
    (column && typeof column.getColDef === 'function'
      ? column.getColDef()
      : column?.colDef) ?? {};

  const isRequired = colDef?.headerComponentParams?.required;
  const template = colDef?.headerComponentParams?.template;

  const [sort, setSort] = useState(() =>
    column && typeof column.getSort === 'function' ? column.getSort() : null
  );

  useEffect(() => {
    if (!column || typeof column.addEventListener !== 'function') return undefined;

    const OnSortChanged = () => {
      setSort(column.getSort?.() ?? null);
    };

    column.addEventListener('sortChanged', OnSortChanged);
    return () => {
      column.removeEventListener('sortChanged', OnSortChanged);
    };
  }, [column]);

  const HandleHeaderClick = (e) => {
    if (enableSorting && typeof progressSort === 'function') {
      progressSort(e.shiftKey);
    }
  };

  const sortSuffix =
    sort === 'asc' ? ' ↑' : sort === 'desc' ? ' ↓' : '';

  const pointerStyle = enableSorting ? { cursor: 'pointer', userSelect: 'none' } : {};

  // template이 있으면 template을 사용 (br 등 HTML 태그 지원)
  if (template) {
    return (
      <div
        role={enableSorting ? 'button' : undefined}
        tabIndex={enableSorting ? 0 : undefined}
        onClick={HandleHeaderClick}
        onKeyDown={(e) => {
          if (!enableSorting || typeof progressSort !== 'function') return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            progressSort(e.shiftKey);
          }
        }}
        dangerouslySetInnerHTML={{ __html: template }}
        style={{
          width: '100%',
          textAlign: 'center',
          fontWeight: 'bold',
          ...pointerStyle,
        }}
      />
    );
  }

  return (
    <div
      role={enableSorting ? 'button' : undefined}
      tabIndex={enableSorting ? 0 : undefined}
      onClick={HandleHeaderClick}
      onKeyDown={(e) => {
        if (!enableSorting || typeof progressSort !== 'function') return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          progressSort(e.shiftKey);
        }
      }}
      style={{
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        ...pointerStyle,
      }}
    >
      {isRequired && <span style={{ color: 'red', marginRight: 4 }}>*</span>}
      <span>
        {displayName}
        {sortSuffix}
      </span>
    </div>
  );
};

export default CustomHeader;
